// extracted by mini-css-extract-plugin
export default {"form":"SearchProductForm_form__1t7RG"};